import { ColumnDef } from '@tanstack/react-table'
import { GetMemberGroupTableData } from '@/modules/manage-member/type'
import DeleteGroupModal from './CellAction/DeleteGroupModal'
import EditGroup from './CellAction/EditGroup'
import { groupNameMapper } from '@/modules/manage-member/mappers'

export const columns: ColumnDef<GetMemberGroupTableData>[] = [
	{
		accessorKey: 'name',
		header: 'ประเภทผู้ดูแลระบบ',
		cell: ({ row }) => (
			<>{groupNameMapper[row.original.name] || row.original.name}</>
		),
	},
	{
		accessorKey: 'id',
		header: 'แก้ไข',
		cell: ({ row }) => <EditGroup id={row.original.id} />,
	},
	{
		id: 'delete',
		header: 'ลบ',
		cell: ({ row }) => <DeleteGroupModal id={row.original.id} />,
	},
]

export const writeAccessorKeys = ['id', 'delete']
